import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal } from "@/components/Reveal";
import { SectionHead } from "@/components/SectionHead";
import { NewsCard } from "@/components/NewsCard";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const NewsSection = () => {
  const { t } = useLanguage();
  const [items, setItems] = useState([]);
  useEffect(() => { axios.get(`${API}/news?limit=3`).then((r) => setItems(r.data)).catch(() => {}); }, []);
  if (items.length === 0) return null;
  const [first, ...rest] = items;

  return (
    <section className="bg-mint/60 py-24 sm:py-32" data-testid="news-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="mb-14 flex flex-col justify-between gap-6 sm:flex-row sm:items-end">
          <SectionHead overline={t.news.overline} title={t.news.title} accent={t.news.accent} />
          <Reveal delay={0.2}>
            <Link to="/actualites" data-testid="news-all-link" className="group flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold transition-colors hover:text-gold-hover">
              {t.news.all}<ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:-translate-y-1 group-hover:translate-x-1" />
            </Link>
          </Reveal>
        </div>
        <div className="grid gap-6 lg:grid-cols-3">
          <Reveal className="lg:col-span-2"><NewsCard item={first} featured index={0} /></Reveal>
          <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-1">
            {rest.map((n, i) => <Reveal key={n.id} delay={0.1 * (i + 1)}><NewsCard item={n} index={i + 1} /></Reveal>)}
          </div>
        </div>
      </div>
    </section>
  );
};

export default NewsSection;
